import React from 'react';
import { observer } from 'mobx-react';
import { DisplayErrorTemplate } from 'themes/common/pages';
import { useStores } from 'core/stores/StoreContext';

const DisplayError = observer((props) => {
    const { errorStore, applicationStore } = useStores();
    return <DisplayErrorTemplate {...props} errorStore={errorStore} applicationStore={applicationStore} />;
});

export default DisplayError;
